import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import type { WithdrawResponse } from '@mobi/account/Areas/Withdraw/Utils/types'

export const trackWithdrawalCancel = (hoursDiff: number) =>
  trackEvent(keys.withdrawalCancel, { hoursDiff })

export const trackWithdrawalPercentage = (withdrawalResponse: WithdrawResponse) => {
  const { balance, withdrawalAmount } = withdrawalResponse
  const fraction = withdrawalAmount / (balance + withdrawalAmount)
  const percentage = Math.floor(fraction * 100)

  trackEvent(keys.withdrawal, { percentage })
}
